import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { clipboard } from 'vue-clipboards';
import Button from 'element-ui/lib/button';
import 'element-ui/lib/theme-chalk/button.css';
import KMessage from '@kso/ui/lib/utils/message';
import { t } from '@kso/ui/lib/config/locale';
import { getUA } from '@kso/util';

var ExternalLinkTip = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "yun-link"
    }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.tipDesc))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.url))])]), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard",
        value: _vm.url,
        expression: "url"
      }],
      on: {
        "success": _vm.copySuccess,
        "error": _vm.copyError
      }
    }, [_vm._v(_vm._s(_vm.btnTxt))])], 1);
  },
  staticRenderFns: [],
  name: 'KExternalLinkTip',
  componentName: 'KExternalLinkTip',
  components: _defineProperty({}, Button.name, Button),
  directives: {
    clipboard: clipboard
  },
  props: {
    url: {
      type: String
    },
    tipDesc: {
      type: String,
      "default": t('combine.externalLinkTip.desc') // 由于小程序限制，请复制链接后使用浏览器访问
    },
    btnTxt: {
      type: String,
      "default": t('combine.externalLinkTip.btnTxt') // 复制链接
    }
  },
  computed: {
    isIE: function isIE() {
      var win = window.top || window;
      var ua = getUA(win.navigator.userAgent);
      return ua && ua.isIE;
    }
  },
  methods: {
    copySuccess: function copySuccess() {
      // 兼容IE浏览器
      if (this.isIE) {
        if (window.clipboardData.setData('text', this.url)) {
          KMessage.success(t('combine.externalLinkTip.tipSucc')); // 复制成功
        } else {
          KMessage.success(t('combine.externalLinkTip.tipFail')); // 复制失败
        }
      } else {
        KMessage.success(t('combine.externalLinkTip.tipSucc')); // 复制成功
      }
    },
    copyError: function copyError() {
      KMessage.success(t('combine.externalLinkTip.tipFail')); // 复制失败
    }
  }
};

ExternalLinkTip.install = function (Vue) {
  Vue.component(ExternalLinkTip.name, ExternalLinkTip);
};

export { ExternalLinkTip as default };
